import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import CustomEvents from 'Flow2/components/CustomCollections/CustomDataConfig/CustomAppEvents';
import { CustomAppEventListener } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';

import * as Panel from 'Flow2/containers/Panel/Panel';

import { getListFromTree } from 'Flow2/util/helperFunctions';

const initialState = {
  language: CustomAppEventListener(CustomEvents.INIT_STATE, "lang"),
  filter: CustomAppEventListener(CustomEvents.INIT_STATE, "filter"),
  clipListViewMode: "grid",
  selectedTags: [],
  selectedModels: [],
  sideBarElements: [],
  toolBarElements: [],
  leftSidebarState: "open",
  metadataState: Panel.PANEL_VIEW_STATE_CLOSED,
  uploadState: "closed",
  tempState: "closed",
  expertSearchState: "closed",
  //searchedObj: {},
  searchedObj: null,
  tempObj: {},
  initialObj: {},
  apiTags: {},
  apiModels: {},
  apiConsumption: {},
  apiConsumptionModels: {},
  appsConfig: {},
  uploadConfig: {},
  expertSearchConfig: {},
  tempConfig: {},
  countriesState: false,
  selectedCountries: [],
  webapiMessage: {},
  webApiFilePath: '',
  uploadDragdropCounter: 0,
  error: "",
  config: {},
  panelViewState: Panel.PANEL_VIEW_STATE_CLOSED,
  showSidebarFilter: 'work'
};

const loadUiConfigStart = (state, action) => {
  return state;
}

const loadUiConfigSuccess = (state, action) => {
	return updateObject(state, { 
        config: action.config, 
        language: action.config.defaultLanguage, 
        panelViewState: action.config.PANEL_VIEW_STATE || Panel.PANEL_VIEW_STATE_CLOSED, 
        metadataState: action.config.PANEL_VIEW_STATE || Panel.PANEL_VIEW_STATE_CLOSED,
        leftSidebarState: action.config.SIDEBAR_VIEW_STATE || "open"
    });
}

const loadUiConfigFail = (state, action) => {
  return updateObject(state, {
    error: 'Could not load UI config.'
  });
}

const getApiConsumptionModels = (apiModels) => {
	const list = getListFromTree(apiModels.Levels, "ID", "Levels");
	for(let key in list) {
		if(!list[key].KCD) {
			delete list[key];
		}
	}
	return list;
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UI_TOGGLE_FILTER:
      const filterToToggle = action.payload.filter;
      let newState = null;
      if (state.filter.indexOf(filterToToggle) > -1) {
        //remove filter from array
        newState = updateObject(state, {
          filter: state.filter.filter(entry => entry !== action.payload.filter)
        });
        localStorage.setItem("filter", JSON.stringify(newState.filter));
      } else {
        //add filter to array
        newState = updateObject(state, {
          filter: state.filter.concat(action.payload.filter)
        });
        localStorage.setItem("filter", JSON.stringify(newState.filter));
      }
      return newState;
    case actionTypes.UI_CHANGE_LANGUAGE:
      return updateObject(state, { language: action.payload.language, direction: (action.payload.language === 'ar' && "rtl") || "ltr" });
    case actionTypes.UI_DISPLAY_COUNTRIES:
      return updateObject(state, { countriesState: action.payload });

    case actionTypes.UI_SELECT_COUNTRIES:
      return updateObject(state, {
        selectedCountries: state.selectedCountries
          .filter(item => item !== action.payload)
          .concat(action.payload)
      });

    case actionTypes.UI_REMOVE_COUNTRIES:
      return updateObject(state, {
        selectedCountries: state.selectedCountries.filter(
          item => item !== action.payload
        )
      });
    case actionTypes.UI_REMOVE_ALLCOUNTRIES:
      return updateObject(state, { selectedCountries: [] });

    case actionTypes.UI_LEFT_SIDEBAR_OPENED:
      return updateObject(state, { leftSidebarState: "open" });
    case actionTypes.UI_LEFT_SIDEBAR_CLOSED:
      return updateObject(state, { leftSidebarState: "closed" });
    case actionTypes.UI_LEFT_SIDEBAR_CLOSING:
      return updateObject(state, { leftSidebarState: "closing" });
    case actionTypes.UI_LEFT_SIDEBAR_OPENING:
      return updateObject(state, { leftSidebarState: "opening" });
    case actionTypes.UI_METADATA_OPENED:
      return updateObject(state, { metadataState: Panel.PANEL_VIEW_STATE_OPEN });
    case actionTypes.UI_METADATA_CLOSED:
      return updateObject(state, { metadataState: Panel.PANEL_VIEW_STATE_CLOSED });
	case actionTypes.UI_PANEL_OPEN:
      return updateObject(state, { panelViewState: Panel.PANEL_VIEW_STATE_OPEN });
    case actionTypes.UI_PANEL_CLOSE:
      return updateObject(state, { panelViewState: Panel.PANEL_VIEW_STATE_CLOSED });
    case actionTypes.UI_SET_CLIPLIST_VIEW_MODE:
      return updateObject(state, {
        clipListViewMode: action.payload.clipListViewMode
      });

    case actionTypes.UI_SAVE_SELECTEDTAGS:
      return updateObject(state, { selectedTags: action.payload.selectedTags });
    case actionTypes.UI_SAVE_SELECTEDMODELS:
      return updateObject(state, {
        selectedModels: action.payload.selectedModels
      });
    case actionTypes.UI_ADD_APITAGS:
      return updateObject(state, { apiTags: action.payload.apiTags });
    case actionTypes.UI_ADD_APIMODELS:
		const consumptionModels = getApiConsumptionModels(action.payload.apiModels);
		return updateObject(state, { apiModels: action.payload.apiModels, apiConsumptionModels: consumptionModels });
    case actionTypes.UI_ADD_APICONSUMPTION:
      return updateObject(state, { apiConsumption: action.payload.apiConsumption });
      
    //AppsConfig  
    case actionTypes.UI_ADD_APIAPPSCONFIG:
      return updateObject(state, { appsConfig: action.payload.appsConfig });

    case actionTypes.UI_ADD_APIUPLOADCONFIG:
      return updateObject(state, { uploadConfig: action.payload.uploadConfig });

    case actionTypes.UI_ADD_APIEXPERTSEARCHCONFIG:
      return updateObject(state, { expertSearchConfig: action.payload.expertSearchConfig });

    //TempForm
    case actionTypes.UI_ADD_TEMPCONFIG:
      return updateObject(state, { tempConfig: action.payload.tempConfig });
    case actionTypes.UI_TEMP_SAVEDATA:
      return updateObject(state, { tempObj: action.tempObj });
    case actionTypes.UI_TEMP_CLOSED:
      return updateObject(state, { tempState: "closed" });
    case actionTypes.UI_TEMP_OPENED:
      return updateObject(state, { tempState: "open" });

    case actionTypes.UI_POST_WEBAPIMESSAGE:
      return updateObject(state, {
        webapiMessage: action.payload.webapiMessage
      });

    case actionTypes.UI_SAVE_WEBAPI_FILEPATH:
      return updateObject(state, { webApiFilePath: action.payload.webApiFilePath });

    case actionTypes.UI_UPLOAD_CLOSED:
      return updateObject(state, { uploadState: "closed" });
    case actionTypes.UI_UPLOAD_OPENED:
      return updateObject(state, { uploadState: "open" });
    case actionTypes.UI_UPLOAD_OPENING:
      return updateObject(state, { uploadState: "opening" });

    case actionTypes.UI_UPLOAD_ADD_DRAGDROP:
      return updateObject(state, { uploadDragDropCounter: action.payload.uploadDragDropCounter });

    case actionTypes.UI_EXPERT_SEARCH_CLOSED:
      return updateObject(state, { expertSearchState: "closed" });
    case actionTypes.UI_EXPERT_SEARCH_OPENED:
      return updateObject(state, { expertSearchState: "open" });
    case actionTypes.UI_EXPERT_SEARCH_SAVEDATA:
      return updateObject(state, { searchedObj: action.searchedObj });
    case actionTypes.UI_EXPERT_SEARCH_SETUPDATA:
      return updateObject(state, { searchedObj: action.initialObj });

    case actionTypes.UI_SELECT_LANGUAGE:
      return updateObject(state, { language: action.language.toLowerCase() });
    case actionTypes.LOAD_UI_CONFIG_START:
      return loadUiConfigStart(state, action);
    case actionTypes.LOAD_UI_CONFIG_SUCCESS:
      return loadUiConfigSuccess(state, action);
    case actionTypes.LOAD_UI_CONFIG_FAIL:
      return loadUiConfigFail(state, action);
      
    case actionTypes.SET_SIDEBAR_FILTER:
        return updateObject(state, { showSidebarFilter: action.payload.show });
    default:
      return state;
  }
};

export default reducer;
